module.exports = __webpack_public_path__ + "static/presidents-message-image-1-800x533-b1b06c235b1f5d3513891efbd8a084e9.jpg";